import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#ece6ed"
        d="M448.657 82.665a7.5 7.5 0 00-10.339-2.366L256 194.716 73.682 80.299a7.499 7.499 0 00-10.339 2.366 7.499 7.499 0 002.366 10.339l186.305 116.919c2.09 1.249 5.193 1.756 7.974 0L446.292 93.004a7.5 7.5 0 002.365-10.339z"
        data-original="#ece6ed"
      ></path>
      <path
        fill="#ffdcd0"
        d="M508.425 272.096l-7.619 112.296-482.603-4.741L0 334.221v-66.975a5 5 0 015-5h474.034l23.21 3.85c3.42 0 6.181 2.69 6.181 6z"
        data-original="#ffdcd0"
      ></path>
      <path
        fill="#ffb5a5"
        d="M505.324 496.81c0 3.31-2.771 6-6.181 6l-42.929 5.44H6.181c-3.41 0-6.181-2.69-6.181-6v-71.169l18.203-51.43 477.314 13.22z"
        data-original="#ffb5a5"
      ></path>
      <path
        fill="#ffc7b6"
        d="M512 334.221v-66.975a5 5 0 00-5-5h-27.966v122.146h21.772z"
        data-original="#ffc7b6"
      ></path>
      <path
        fill="#f9a791"
        d="M500.806 384.392h-21.772v94.743c0 16.08-13.429 29.116-29.995 29.116h56.779c3.414 0 6.181-2.686 6.181-6v-71.169l-11.717-44.345z"
        data-original="#f9a791"
      ></path>
      <path
        fill="#fe93bb"
        d="M426.663 362.816c-42.669 0-42.669-28.597-85.337-28.597-42.667 0-42.667 28.597-85.333 28.597-42.665 0-42.665-28.597-85.33-28.597-42.666 0-42.666 28.597-85.332 28.597-42.665 0-42.665-28.597-85.331-28.597v30.73l3.808 15L0 394.95v36.135c42.665 0 42.665 28.597 85.331 28.597s42.666-28.597 85.332-28.597c42.665 0 42.665 28.597 85.33 28.597 42.666 0 42.666-28.597 85.333-28.597 42.668 0 42.668 28.597 85.337 28.597 34.012 0 40.913-18.17 63.924-25.543v-96.865c-23.011 7.372-29.912 25.542-63.924 25.542z"
        data-original="#fe93bb"
      ></path>
      <path
        fill="#fe76a8"
        d="M512 334.221v30.729l-3.575 16.948L512 394.95v36.131c-15.051 0-24.786 3.56-32.966 8.17v-96.86c8.18-4.61 17.915-8.17 32.966-8.17z"
        data-original="#fe76a8"
      ></path>
      <g fill="#f6f0f7">
        <ellipse
          cx="256"
          cy="411.249"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="85.331"
          cy="411.249"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="426.663"
          cy="411.249"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="170.663"
          cy="379.652"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
        <ellipse
          cx="341.326"
          cy="379.652"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
      </g>
      <path
        fill="#ece6ed"
        d="M512 364.95v30c-8.53 0-15.453-6.71-15.453-15 0-8.28 6.923-15 15.453-15z"
        data-original="#ece6ed"
      ></path>
      <path
        fill="#f6f0f7"
        d="M15.453 379.95c0 8.29-6.923 15-15.453 15v-30c8.53 0 15.453 6.72 15.453 15z"
        data-original="#f6f0f7"
      ></path>
      <g fill="#ffc7b6">
        <circle
          cx="457.578"
          cy="298.769"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="395.755"
          cy="298.769"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="426.669"
          cy="329.504"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="116.239"
          cy="298.908"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="170.663"
          cy="306.388"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="256"
          cy="329.504"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="341.326"
          cy="306.388"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="85.331"
          cy="329.504"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
        <circle
          cx="54.422"
          cy="298.908"
          r="7.726"
          data-original="#ffc7b6"
        ></circle>
      </g>
      <path
        fill="#98d5b9"
        d="M309.279 105.851H202.723a5.443 5.443 0 00-4.714 2.721l-53.278 92.281a5.444 5.444 0 000 5.443l23.935 41.456 31.303 45.46a5.442 5.442 0 004.714 2.721l101.412-.096a5.443 5.443 0 004.714-2.721l49.947-86.781a5.444 5.444 0 000-5.443l-37.385-76.077-9.378-16.243a5.447 5.447 0 00-4.714-2.721z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#7acaa6"
        d="M367.263 206.293l-53.268 92.275a5.455 5.455 0 01-4.717 2.721H202.724a5.455 5.455 0 01-4.717-2.721L168.67 247.75c85.543 25.337 170.679-35.896 154.705-122.937l43.888 76.037a5.406 5.406 0 010 5.443z"
        data-original="#7acaa6"
      ></path>
      <path
        fill="#98d5b9"
        d="M471.67 32.789h-58.731a3 3 0 00-2.598 1.5l-29.366 50.863a3 3 0 000 3l13.192 22.85 17.254 25.056a3 3 0 002.598 1.5l55.896-.053a3 3 0 002.598-1.5l27.529-47.832a3 3 0 000-3l-20.606-41.932-5.169-8.953a2.996 2.996 0 00-2.597-1.499z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#7acaa6"
        d="M503.63 88.15l-29.36 50.86c-.54.93-1.53 1.5-2.6 1.5h-58.73c-1.07 0-2.06-.57-2.6-1.5L394.17 111c7.6 3.37 16.02 5.24 24.87 5.24 33.95 0 61.48-27.53 61.48-61.48 0-3.94-.37-7.79-1.08-11.52l24.19 41.91c.54.93.54 2.07 0 3z"
        data-original="#7acaa6"
      ></path>
      <path
        fill="#98d5b9"
        d="M352.83 63.752h-12.5v-12.5a7.5 7.5 0 00-15 0v12.5h-12.5a7.5 7.5 0 000 15h12.5v12.5a7.5 7.5 0 0015 0v-12.5h12.5a7.5 7.5 0 000-15zM276 23.75h-12.5v-12.5a7.5 7.5 0 00-15 0v12.5H236a7.5 7.5 0 000 15h12.5v12.5a7.5 7.5 0 0015 0v-12.5H276a7.5 7.5 0 000-15zm-76.83 25h-12.5v-12.5a7.5 7.5 0 00-15 0v12.5h-12.5a7.5 7.5 0 000 15h12.5v12.5a7.5 7.5 0 0015 0v-12.5h12.5a7.5 7.5 0 000-15z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#ece6ed"
        d="M286.762 211.071h-61.523a7.5 7.5 0 010-15h61.523a7.5 7.5 0 010 15z"
        data-original="#ece6ed"
      ></path>
      <path
        fill="#f6f0f7"
        d="M294.262 134.306v-1.337a7.5 7.5 0 00-15 0v1.337c0 12.119-8.172 22.79-19.872 25.949l-3.39.915-3.39-.915c-11.7-3.159-19.872-13.83-19.872-25.949v-1.337a7.5 7.5 0 00-15 0v1.337c0 14.126 7.127 26.987 18.349 34.632-11.223 7.645-18.349 20.506-18.349 34.633s7.127 26.988 18.349 34.633c-11.223 7.645-18.349 20.506-18.349 34.633v1.337a7.5 7.5 0 0015 0v-1.337c0-12.119 8.171-22.79 19.872-25.949l3.39-.915 3.39.915c11.701 3.159 19.872 13.83 19.872 25.949v1.337a7.5 7.5 0 0015 0v-1.337c0-14.126-7.127-26.988-18.349-34.633 11.223-7.645 18.349-20.506 18.349-34.633 0-14.126-7.127-26.988-18.349-34.632 11.222-7.645 18.349-20.507 18.349-34.633zM259.39 229.52l-3.39.915-3.39-.915c-11.701-3.159-19.872-13.83-19.872-25.949s8.171-22.79 19.872-25.949l3.39-.915 3.39.915c11.701 3.159 19.872 13.83 19.872 25.949s-8.172 22.789-19.872 25.949z"
        data-original="#f6f0f7"
      ></path>
      <path
        fill="#98d5b9"
        d="M99.061 32.791H40.33a3 3 0 00-2.598 1.5L8.366 85.154a3 3 0 000 3l13.192 22.85 17.254 25.056a3 3 0 002.598 1.5l55.896-.053a3 3 0 002.598-1.5l27.529-47.832a3 3 0 000-3l-20.606-41.932-5.169-8.953a2.999 2.999 0 00-2.597-1.499z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#7acaa6"
        d="M131.021 88.152l-29.36 50.86c-.54.93-1.53 1.5-2.6 1.5h-58.73c-1.07 0-2.06-.57-2.6-1.5l-16.17-28.01c7.6 3.37 16.02 5.24 24.87 5.24 33.95 0 61.48-27.53 61.48-61.48 0-3.94-.37-7.79-1.08-11.52l24.19 41.91c.54.93.54 2.07 0 3z"
        data-original="#7acaa6"
      ></path>
    </svg>
  );
}

export default Icon;
